import { Routes } from '@angular/router';
import { authGuard } from './app/core/auth/auth.guard';
import { AppLayout } from './app/layout/component/app.layout';
import { Notfound } from './app/pages/notfound/notfound';
import { Overview } from './app/pages/overview/overview';
import { MerchantList } from './app/pages/merchants/merchant-list';
import { MerchantPage } from './app/pages/merchants/merchant-page';
import { FauxMerchants } from './app/pages/merchants/faux-merchants';
import { Locations } from './app/pages/locations/locations';
import { LocationDetail } from './app/pages/locations/location-detail';
import { LocationUsers } from './app/pages/location-users/location-users';
import { StoreEdges } from './app/pages/edges/edges';
import { Payments } from './app/pages/payments/payments';
import { PaymentFlows } from './app/pages/payment-flows/payment-flows';
import { GlobalPaymentMethods } from './app/pages/payment-methods/payment-methods';
import { Orders } from './app/pages/orders/orders';
import { CourierCosts } from './app/pages/courier-costs/courier-costs';
import { Instances } from './app/pages/instances/instances';
import { Consumers } from './app/pages/consumers/consumers';
import { Products } from './app/pages/products/products';
import { XtItems } from './app/pages/xt-items/xt-items';
import { OhlqCatalog } from './app/pages/ohlq/ohlq-catalog';
import { Profile } from './app/pages/profile/profile';
import { Users } from './app/pages/users/users';
import { RolePermissionsPage } from './app/pages/role-permissions/role-permissions';
import { Tokens } from './app/pages/tokens/tokens';
import { DoorDashIntegration } from './app/pages/integrations/doordash-integration';
import { XtIntegration } from './app/pages/integrations/xt-integration';
import { OrderHandoffPage } from './app/pages/order-handoff/order-handoff';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [authGuard],
        children: [
            { path: '', component: Overview },
            { path: 'merchants', component: MerchantList },
            // Before :merchantId, or "faux" would be read as a merchant id.
            { path: 'merchants/faux', component: FauxMerchants },
            // Also catches old /merchants/<locationId> links: MerchantPage redirects a non-GUID to /locations.
            { path: 'merchants/:merchantId', component: MerchantPage },
            { path: 'locations', component: Locations },
            { path: 'locations/:locationId', component: LocationDetail },
            { path: 'location-users', component: LocationUsers },
            { path: 'edges', component: StoreEdges },
            { path: 'payments', component: Payments },
            { path: 'payment-flows', component: PaymentFlows },
            { path: 'payment-methods', component: GlobalPaymentMethods },
            { path: 'orders', component: Orders },
            { path: 'courier-costs', component: CourierCosts },
            { path: 'instances', component: Instances },
            { path: 'consumers', component: Consumers },
            { path: 'products', component: Products },
            { path: 'ohlq', component: OhlqCatalog },
            { path: 'profile', component: Profile },
            { path: 'users', component: Users },
            { path: 'roles', component: RolePermissionsPage },
            { path: 'tokens', component: Tokens },
            { path: 'integrations/xt', component: XtIntegration },
            // Which system receives online orders (store Edge or legacy XT), its circuit breakers, and the hand-offs
            // that are not getting through.
            { path: 'order-handoff', component: OrderHandoffPage },
            // The XT replica's item table, one onboarded merchant at a time. Sits beside the XT
            // integration rather than under Catalog: it is XT's own row, not the platform's projection.
            { path: 'xt-items', component: XtItems },
            { path: 'integrations/doordash', component: DoorDashIntegration }
        ]
    },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
